import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import useIsPluginVersion from '@hooks/useIsPluginVersion';
import { useAppSelector } from '@reducers/index';
import React from 'react';
import AppContextContent from './AppContextContent';
import AppContextSidebar from './AppContextSidebar';
import AppParser from './AppParser';
function AppWorkerContext(props) {
    const { children } = props;
    const { app, version } = useAppSelector(state => ({
        app: state.app.app,
        version: state.settings.version,
    }));
    // looks not smooth enough. will be false first time and will switch later.
    const isAppWithBgPreload = useIsPluginVersion('11.0.0');
    if (!version) {
        // wait for init event first
        return null;
    }
    if (!isAppWithBgPreload) {
        return (_jsx(AppContextContent, { children: _jsx(AppContextSidebar, { children: children }) }));
    }
    if (app === 'sidebar') {
        return _jsx(AppContextSidebar, { children: children });
    }
    if (app === 'content') {
        return _jsx(AppContextContent, { children: children });
    }
    return _jsx(AppParser, { children: children });
}
export default AppWorkerContext;
